import { render } from "./EnquiryClosedList.vue?vue&type=template&id=e9ee0b10"
import script from "./EnquiryClosedList.vue?vue&type=script&lang=js"
export * from "./EnquiryClosedList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__